import { useEffect, useState } from "react";
import { PESSOA_ONLINE_THRESHOLD_MINUTOS } from "@workflow/types";
import { subscribeToPresenceClock } from "./use-presence-clock";

function isOnline(ultimaInteracao?: string): boolean {
  if (!ultimaInteracao) return false;
  const limiteMs = PESSOA_ONLINE_THRESHOLD_MINUTOS * 60_000;
  return Date.now() - new Date(ultimaInteracao).getTime() <= limiteMs;
}

/**
 * Deriva a bolinha "online" a partir de `ultimaInteracao`. Sem registro ou
 * fora da janela: sem bolinha — só existe o estado positivo. Reavalia a cada
 * pulso do relógio de presença compartilhado (§`use-presence-clock`) para não
 * depender de um refresh de página em telas que ficam abertas, sem um
 * `setInterval` por avatar renderizado.
 */
export function usePessoaOnline(ultimaInteracao?: string): boolean {
  const [online, setOnline] = useState(() => isOnline(ultimaInteracao));

  useEffect(() => {
    setOnline(isOnline(ultimaInteracao));
    return subscribeToPresenceClock(() => setOnline(isOnline(ultimaInteracao)));
  }, [ultimaInteracao]);

  return online;
}
